import { User } from 'graphql.generated';
import { identifyUser } from 'shared/helpers/segment/identifyUser';
import { trackEvent } from 'shared/helpers/segment/trackEvent';
import { EventNames, BaseTaxonomy } from 'shared/tracking/contracts';
import { Segment } from '../AuthModal.types';
import { getUser } from './getUser';

const getRegTaxonomy = (user: User, segment: Segment): BaseTaxonomy => {
    return {
        countryCode: 'gb',
        platform: 'React',
        brand: 'zoopla',
        userId: user.userUuid || '',
        brandPrimary: user.brandPrimary || '',
        aboutMeStatus: user.senderPropertyStatus || '',
        signedInStatus: user.loggedIn ? 'signed in' : 'signed out',
        registrationPlatform: user.registrationSources?.join(', '),
        registered: user.registered,
        userCreationDate: user.creationDate,
        section: segment?.section || 'unknown',
        page: segment?.page || 'unknown',
        activity: segment?.activity || 'unknown'
    } as BaseTaxonomy;
};

const getOptinTaxonomy = (user: User, segment: Segment): BaseTaxonomy => ({
    brand: 'zoopla',
    section: segment.section as BaseTaxonomy['section'],
    page: segment.page as BaseTaxonomy['page'],
    activity: segment.activity as BaseTaxonomy['activity'],
    userId: user.userUuid || ''
});

const eventTrackingMap = {
    reg: EventNames.REGISTRATION,
    signin: EventNames.SIGN_IN,
    optin: EventNames.EMAIL_OPT_IN
};

export const trackAuthSegmentEvent = async (
    event: keyof typeof eventTrackingMap,
    segment: Segment | undefined,
    user?: User
) => {
    if (!segment) return;

    const userData = user ? user : await getUser();
    const eventName = eventTrackingMap[event];

    if (event === 'optin') {
        trackEvent(eventName, getOptinTaxonomy(userData || {}, segment));

        return;
    }

    if (userData) {
        const taxonomy = getRegTaxonomy(userData, segment);

        await identifyUser(window);
        trackEvent(eventName, taxonomy);
    }
};
